import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { PositionedModal } from 'common/components/PositionedModal';

type FocusPlanDeleteConfirmProps = {
  open: boolean;
  itemTitle?: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const FocusPlanDeleteConfirm: React.FC<FocusPlanDeleteConfirmProps> = ({ open, itemTitle, onCancel, onConfirm }) => (
    <PositionedModal open={open} onClose={onCancel} size="small">
      <Modal.Header>Remove focus plan item</Modal.Header>
      <Modal.Content>
        <p>
          Are you sure you want to remove <strong>{itemTitle ?? 'this item'}</strong> from your Focus Plan?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="red" onClick={onConfirm} data-testid="confirm-delete-focusplan">Remove</Button>
      </Modal.Actions>
    </PositionedModal>
  );

export default FocusPlanDeleteConfirm;
